/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css } from 'aphrodite';

import { BlendBridge } from 'blb-types/blendBridge';
import { Text } from '@blend/enterprise-components';

import { ContactCard } from '../ContactCard';
import { cardWrapperStyles } from './SectionCard';
import { DashboardSection } from './DashboardSection';

export namespace Contacts {
  export interface Props {
    contactList?: BlendBridge.API.ContactListItem[];
  }
}

const EmptyContactsText = () => <Text>None for this loan</Text>;

const getContactConfig = (contacts: BlendBridge.API.Contact[]) =>
  !contacts || !contacts.length ? (
    <EmptyContactsText />
  ) : (
    <div className={css(cardWrapperStyles.cardGroup)}>
      {contacts.map((contact: BlendBridge.API.Contact) => (
        <ContactCard contact={contact} key={contact.email} />
      ))}
    </div>
  );

export const Contacts = ({ contactList = [] }: Contacts.Props): JSX.Element => {
  return (
    <DashboardSection
      sectionConfigs={contactList.map(({ contacts, title }) => ({ content: getContactConfig(contacts), title }))}
      sectionHeader="Contacts"
    />
  );
};
